var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[(_vm.html)?_c('div',[_c('span',{class:_vm.classes,domProps:{"innerHTML":_vm._s(this.label)}})]):_c('div',[_c('div',{class:_vm.classes},[_vm._v(_vm._s(this.label))])])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }